import { render, staticRenderFns } from "./SysDialog.vue?vue&type=template&id=065a931e&"
import script from "./SysDialog.vue?vue&type=script&lang=js&"
export * from "./SysDialog.vue?vue&type=script&lang=js&"
import style0 from "./SysDialog.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports